export enum VehicleTypeEnum {
  Car = 'VEHICLE_TYPE_CAR',
  Motorcycle = 'VEHICLE_TYPE_MOTORCYCLE',
  Truck = 'VEHICLE_TYPE_TRUCK',
  Bus = 'VEHICLE_TYPE_BUS',
}

export enum VehicleFormatEnum {
  Local = 'VEHICLE_FORMAT_LOCAL',
  Foreign = 'VEHICLE_FORMAT_FOREIGN',
}

export interface IVehicle {
  uuid: string;
  type: VehicleTypeEnum;
  vrp: string;
  vrp_format: VehicleFormatEnum;
  is_main?: boolean;
}

export const IVehicleTypeLabel = {
  [VehicleTypeEnum.Car]: 'Легковые',
  [VehicleTypeEnum.Truck]: 'Тягачи',
  [VehicleTypeEnum.Motorcycle]: 'Мотоцикл',
  [VehicleTypeEnum.Bus]: 'Автобусы',
};
